// extracted by mini-css-extract-plugin
export default {"avatarBox":"dCqDR6rZKbknglfuzljF","avatarUpload":"oobGSllHHQ6myDMexqyG"};